<template>
    <div>
        <div v-show="!rateStatus">
            <div style="width:10rem;height:2.67rem;background:rgba(255,255,255,1);">

                <div style="height:0.65rem;"></div>

                <div class="flex-center">
                    <template v-for="(item,index) in 5" >
                        <img v-show="index<rateInfo.starLevel" @click="clickStar(item)" src="../../image/rate/star-selected.png" :style="(item==5?'':'margin-right:0.39rem;')+'width:0.67rem;height:0.67rem;'">
                        <img v-show="index>=rateInfo.starLevel" @click="clickStar(item)" src="../../image/rate/star-common.png" :style="(item==5?'':'margin-right:0.39rem;')+'width:0.67rem;height:0.67rem;'">
                    </template>
                </div>
                <div :style="'padding-top: 0.63rem;height:0.32rem;line-height:0.32rem;text-align: center;font-size:0.32rem;font-family:PingFang SC;font-weight:400;'+(rateInfo.starLevel==0?'color:rgba(153,153,153,1);':'color:rgba(255,113,61,1);')">{{['您的评价是对大兴最大的支持！','特别不满意，体验非常差','不满意，体验略差','感觉还行，体验一般','挺满意，体验很好','特别满意，体验非常棒'][rateInfo.starLevel]}}</div>
            </div>

            <div style="padding-top:0.4rem;box-sizing: border-box;width:10rem;background:rgba(255,255,255,1);">
                <div  class="flex-start" style="margin-left:1.48rem;flex-wrap: wrap;">
                    <div v-for="(item,index) in currentRateList" @click="clickRateOption(index)" class="flex-center" :style="'margin-right: 0.32rem;margin-bottom: 0.4rem;box-sizing: border-box;width:3.36rem;height:0.75rem;border-radius:0.37rem;font-size:0.32rem;font-family:PingFang SC;font-weight:400;'+(selectedIndex.indexOf(index)>=0?'background:rgba(230,244,255,1);border:1px solid rgba(52,164,251,1);color:rgba(52,164,251,1);':'background:rgba(255,255,255,1);border:1px solid rgba(233,233,233,1);color:rgba(51,51,51,1);')">{{item}}</div>
                </div>
            </div>


            <div class="flex-center" style="width:10rem;height:3.65rem;background:rgba(255,255,255,1);">
                <textarea @input="rateInfo.suggestion=$event.target.value" id="rateSuggestion"  placeholder="请留下您的宝贵意见，让我们能够更好的服务您！" style="padding:0.31rem 0.32rem;box-sizing: border-box;width:9.2rem;height:2.85rem;background:rgba(250,250,250,1);border:1px solid rgba(233,233,233,1);border-radius:0.13rem;font-size:0.37rem;font-family:PingFang SC;font-weight:400;"></textarea>
            </div>

            <div class="flex-center" style="width:10rem;height:1.6rem;background:rgba(255,255,255,1);">
                <div v-show="selectedIndex.length==0" class="flex-center" style="width:9.36rem;height:1.17rem;background:rgba(174,219,253,1);border-radius:0.59rem;font-size:0.48rem;font-family:PingFang SC;font-weight:500;color:rgba(223,241,254,1);">提交</div>
                <div v-show="selectedIndex.length>0" @click="submit" class="flex-center" style="width:9.36rem;height:1.17rem;background:rgba(52,164,251,1);border-radius:0.59rem;font-size:0.48rem;font-family:PingFang SC;font-weight:500;color:rgba(255,255,255,1);">提交</div>
            </div>
        </div>
        <div v-show="rateStatus" class="flex-center" style="height: 10rem;">
            <img src="../../image/rate/temp.png" style="width:2.4rem;height:2rem;">
        </div>
    </div>
</template>

<script>
    import request from '@/utils/request';
    import {
        Toast
    } from 'vant';

    export default {
        name: "rate",
        components: {
            [Toast.name]: Toast
        },
        data() {
            return {
                badRateList:[
                    "服务态度恶劣",
                    "索要好评",
                    "服务过程不认真"
                ],
                goodRateList:[
                    "服务态度很好",
                    "服务过程很专业"
                ],
                currentRateList:[],
                selectedIndex:[],

                rateStatus:false,
                rateInfo:{
                    businessItemId: "",
                    evaluationType: "",
                    memberId: "",
                    plateNumber: "",
                    references: [],
                    starLevel: 0,
                    suggestion: ""
                },
            }
        },
        created:function(){
            let id=this.$route.query.id;
            let itemType=this.$route.query.itemType;
            let memberId=this.$route.query.memberId;

            let evaluationTypeMapping={
                "一键救援":"RESCUE",
                "车险报价":"CAR_INSURANCE_QUOTE",
                "透明服务":"TRANSPARENT_SERVICE"
            };

            let rateInfo=this.rateInfo;
            rateInfo.businessItemId=id;
            rateInfo.evaluationType=evaluationTypeMapping[itemType];//XXX
            rateInfo.memberId=memberId;

            this.rateInfo=rateInfo;

            this.setRateStatus(id);
        },
        methods: {
            setRateStatus(id){
                let _this=this;
                Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    overlay:true
                });
                request({
                    url: '/evaluation/isEvaluate?id='+id,
                    method: 'GET',
                }).then(res=>{
                    Toast.clear();
                    if(res.code=="200"){
                        _this.rateStatus=res.data;
                    }else{
                        Toast(res.msg);
                    }
                });
            },
            clickRateOption(index){
                let selectedIndex=this.selectedIndex;
                let indexOfSelected=selectedIndex.indexOf(index);
                if(indexOfSelected>=0){
                    selectedIndex.splice(indexOfSelected,1);
                }else{
                    selectedIndex.push(index);
                }
                this.selectedIndex=selectedIndex;
            },
            clickStar(index){
                let currentRateList=[];
                if(index>=1 && index<=4){
                    let badRateList=this.badRateList;
                    currentRateList=badRateList;
                }else if(index==5){
                    let goodRateList=this.goodRateList;
                    currentRateList=goodRateList;
                }


                this.selectedIndex=[];
                this.currentRateList=currentRateList;
                this.rateInfo.starLevel=index;
            },
            submit:function () {
                let _this=this;
                let rateInfo=this.rateInfo;
                let currentRateList=this.currentRateList;
                let selectedIndex=this.selectedIndex;

                rateInfo.references=selectedIndex.map((item)=>{
                    return currentRateList[item];
                })
                Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    overlay:true
                });
                request({
                    url: '/evaluation/create',
                    method: 'POST',
                    data:rateInfo
                }).then(res=>{
                    Toast.clear();
                    if(res.code=="200"){
                        _this.setRateStatus(rateInfo.businessItemId);
                    }else{
                        Toast(res.msg);
                    }
                });

            }
        }
    }
</script>

<style scoped>
    #rateSuggestion::-webkit-input-placeholder{
        color:rgba(204,204,204,1);
    }

    .flex-center{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:center;
    }
    .flex-start{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:flex-start;
    }
    .flex-end{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:flex-end;
    }
    .flex-between{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:space-between;
    }
    .flex-around{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:space-around;
    }

</style>
